import { useEffect } from "react";

/**
 * Calls `handler` when Escape is pressed, but only while `active` is true.
 * Used to make overlays and dialogs dismissable by keyboard.
 *
 * @param {boolean}  active  Whether the listener is attached (e.g. modal open).
 * @param {Function} handler Called on Escape.
 */
export default function useOnEscape(active, handler) {
    useEffect(() => {
        if (!active) return undefined;

        const onKeyDown = (e) => {
            if (e.key === "Escape") handler();
        };

        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [active, handler]);
}
